"use client";

import React from "react";
import { FileText } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note?: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Polymer Melt Filtration",
    heading: "Need Custom Screen Packs or Melt Filtration Specifications?",
    lead: "Share your operating temperatures, target micron retention, and screen pack dimensions for technical review and quotation.",
    secondaryLabel: "Explore Screen Packs",
    note: "Custom outer rings, multilayer spot-welding and sintered screen configurations available."
  },
  zh: {
    eyebrow: "聚合物熔体过滤",
    heading: "需要定制挤出换网滤网包或熔体过滤规格？",
    lead: "提供您的工作温度、目标微米精度以及滤网组件几何尺寸，获取工程技术评审与报价。",
    secondaryLabel: "浏览换网滤片",
    note: "可按需提供定制外包边、多层点焊及烧结复合网组件。"
  },
  es: {
    eyebrow: "Filtración de polímeros fundidos",
    heading: "¿Necesita paquetes de filtros a medida para polímeros?",
    lead: "Comparta temperaturas de trabajo, micraje requerido y dimensiones de los filtros para su evaluación técnica.",
    secondaryLabel: "Ver paquetes de filtros",
    note: "Configuraciones con bordes metálicos, puntos de soldadura o sinterizadas disponibles."
  },
  de: {
    eyebrow: "Polymerschmelzefiltration",
    heading: "Benötigen Sie maßgeschneiderte Siebpakete für Polymere?",
    lead: "Senden Sie uns Betriebstemperaturen, gewünschte Feinheiten und Abmessungen für eine technische Auslegung.",
    secondaryLabel: "Siebpakete ansehen",
    note: "Eingefasste Ränder, punktgeschweißte Mehrlagen-Pakete und Sinterverbunde lieferbar."
  },
  fr: {
    eyebrow: "Filtration des polymères en fusion",
    heading: "Besoin de packs filtrants sur mesure pour polymères ?",
    lead: "Transmettez vos températures de service, seuils de rétention et dimensions pour analyse technique et devis.",
    secondaryLabel: "Découvrir les packs filtrants",
    note: "Finitions bordées, soudées par points ou laminés frittés disponibles sur demande."
  },
  pt: {
    eyebrow: "Filtração de polímeros fundidos",
    heading: "Necessita de pacotes de filtros sob medida para polímeros?",
    lead: "Envie suas temperaturas de operação, retenção micrométrica e dimensões para avaliação técnica e cotação.",
    secondaryLabel: "Ver pacotes de filtros",
    note: "Bordas metálicas, telas soldadas por ponto ou laminados sinterizados sob medida."
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const c = pick(lang, copyData);
  return <CtaBand id="quotebanner" eyebrow={c.eyebrow} heading={c.heading} lead={c.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: c.secondaryLabel,
    to: "/ScreenPacksPage",
    icon: FileText
  }} note={c.note} />;
}